import PaymentScheduleList from '../../../../components/People/EmployeeLoan/Lines/PaymentScheduleList'
import PaymentScheduleModal from '../../../../components/People/EmployeeLoan/Lines/PaymentScheduleModal'
import React, {Fragment} from 'react'

function PaymentSchedule(props) {
  return (
    <Fragment>
      <PaymentScheduleModal {...props} />
      <PaymentScheduleList {...props} />
    </Fragment>
  )
}

export default PaymentSchedule
